import styles from '../index.less';

const UserAmountCard = ({ userAmount }) => {
  return (
    <div className={styles.userInfo}>
      <p className={styles.userText}>我的云豆</p>
      <p className={styles.userAmount}>{userAmount}</p>
    </div>
  );
};
export default UserAmountCard;
